
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Popover, Pane, Body1, majorScale } from '@segment/react-ui-library'
import WorkspaceNotificationsHeaderTab from './WorkspaceNotificationsHeaderTab'
import WorkspaceNotificationsBody from './WorkspaceNotificationsBody'
import css from './WorkspaceNotifications.module.css'
import { success } from '@segment/notify'
import Offscreen from 'ui/Offscreen'
import EmptyState from './EmptyState'

class WorkspaceNotifications extends Component {
  constructor () {
    super()
    this.state = {
      tab: 'alerts'
    }

    this.getCount = this.getCount.bind(this)
    this.joinUxClick = this.joinUxClick.bind(this)
  }

  render () {
    const { user, workspace, notifications, workspaceNotificationViewed, onNotificationClick } = this.props
    const notificationsByCategory = notifications
      .filter(update => update.category === this.state.tab)
      .map(update => (
        <WorkspaceNotificationsBody
          title={update.title}
          body={update.body}
          timestamp={update.timestamp}
          url={update.url}
          category={update.category}
          read={update.read}
          onClick={() => onNotificationClick(workspace, user, update.category, update.title)}
          key={update.id} />
        )
      )

    const alertsCount = this.getCount(notifications, 'alerts')
    const hasNotifications = alertsCount > 0
    const hasNotificationsByCategory = notificationsByCategory.length > 0

    const WorkspaceNotificationContent = () => (
      <Pane
        display='flex'
        width='416px'
        flexDirection='column'>
        <Pane display='flex' className={css.Header}>
          <WorkspaceNotificationsHeaderTab
            title='Alerts'
            active={this.state.tab === 'alerts'}
            count={alertsCount}
            onClick={() => this.setState({ tab: 'alerts' })} />
          <WorkspaceNotificationsHeaderTab
            title='Updates'
            active={this.state.tab === 'updates'}
            onClick={() => this.setState({ tab: 'updates' })} />
        </Pane>
        <Pane className={css.BodyPane} data-emptyState={!hasNotificationsByCategory}>
          {hasNotificationsByCategory ? notificationsByCategory : notificationsEmptyState}
        </Pane>
        <Pane
          is='button'
          display='flex'
          padding={majorScale(2)}
          textColor='muted'
          className={css.Footer}
          onClick={this.joinUxClick}>
          <Body1 textColor='muted'>Have feedback for us? <span style={{ textDecoration: 'underline' }}>Join our UX Research Program.</span></Body1>
        </Pane>
      </Pane>
    )

    return (
      <Popover
        openClass={css.active}
        marginRight={majorScale(2)}
        content={<WorkspaceNotificationContent />}
        side='bottom'
        onOpen={() => workspaceNotificationViewed(workspace, user)}
        useSmartPositioning={false}>
        <button className={css.ShowNotificationsButton} type='button'>
          <Offscreen>Workspace Notifications</Offscreen>
          <svg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'>
            <path d='M10 14H6c0 1.1.9 2 2 2s2-.9 2-2zm5-3h-.5c-.7-.7-1.5-1.7-1.5-3V5c0-2.8-2.2-5-5-5S3 2.2 3 5v3c0 1.3-.8 2.3-1.5 3H1c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1z' fill='#FFF' fillRule='evenodd' />
          </svg>
          {hasNotifications && <span className={css.UnreadNotificationsDot} data-hasNotifications={hasNotifications} />}
        </button>
      </Popover>
    )
  }

  getCount (items, tab) {
    return items.reduce((count, item) => {
      if (item.category === tab && !item.read) {
        return count + 1
      }
      return count
    }, 0)
  }

  joinUxClick () {
    const { workspace, user, workspaceNotificationUxClicked } = this.props
    workspaceNotificationUxClicked(workspace, user)
    success('Thanks for joining Segment’s UX Research Program! We’ve enrolled you in our program and will be following up by email with next steps.', 5000)
  }
}

const notificationsEmptyState = (
  <div className={css.EmptyStateBody}>
    <EmptyState />
    <Body1 textColor='muted'>You don’t have any alerts</Body1>
  </div>
)

WorkspaceNotifications.propTypes = {
  fetchWorkspaceNotifications: PropTypes.func.isRequired,
  notifications: PropTypes.arrayOf(PropTypes.shape({
    body: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    read: PropTypes.bool.isRequired,
    timestamp: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })).isRequired,
  onNotificationClick: PropTypes.func.isRequired,
  workspace: PropTypes.object.isRequired,
  workspaceNotificationUxClicked: PropTypes.func.isRequired,
  workspaceNotificationViewed: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
}

WorkspaceNotifications.displayName = 'WorkspaceNotifications'

export default WorkspaceNotifications



// WEBPACK FOOTER //
// ./components/WorkspaceNotifications/index.js